import { InjectionToken } from '@angular/core';

export const DATA_PREVIEW_DATA_URL = new InjectionToken<string>(
  'DATA_PREVIEW_DATA_URL'
);
export const DATA_PREVIEW_FRAMEWORK_URL = new InjectionToken<string>(
  'DATA_PREVIEW_FRAMEWORK_URL'
);
export const DATA_PREVIEW_CODE_URL = new InjectionToken<string>(
  'DATA_PREVIEW_CODE_URL'
);

export const DATA_POLLUTION_PREVIEW_DATA_URL = new InjectionToken<string>(
  'DATA_POLLUTION_PREVIEW_DATA_URL'
);
export const DATA_POLLUTION_PREVIEW_FRAMEWORK_URL = new InjectionToken<string>(
  'DATA_POLLUTION_PREVIEW_FRAMEWORK_URL'
);
export const DATA_POLLUTION_PREVIEW_CODE_URL = new InjectionToken<string>(
  'DATA_POLLUTION_PREVIEW_CODE_URL'
);
